
import { useNotificationsStore } from './store';
import {
    NotificationDescriptor,
    NotificationLevel,
} from './types';

// Legacy support layer via plugin, that allows no change
// for any client/federation/whatever
export const NotificationVuePlugin = {
    install(Vue: any) {
        // eslint-disable-next-line no-param-reassign
        Vue.prototype.$notify = notify;
    },
};

function notify(level: NotificationLevel, message: string, durationMs?: number): void;
function notify(notification: NotificationDescriptor): void;
function notify(levelOrNotification: NotificationLevel | NotificationDescriptor, message?: string, durationMs?: number): void {
    if (typeof levelOrNotification === 'string') {
        const iconName = (() => {
            switch (levelOrNotification) {
                case 'info':
                    return 'status-info-filled';
                case 'warning':
                    return 'status-danger-filled';
                case 'error':
                    return 'status-warning-filled';
            }
        })();
        const notification: NotificationDescriptor = {
            iconName,
            message: message!,
            timeoutMs: durationMs,
        };

        useNotificationsStore().showNotification(notification);
    } else {
        useNotificationsStore().showNotification(levelOrNotification);
    }
}

export type NotifyFunction = typeof notify;
